import { createAction, props } from '@ngrx/store';
import { BusinessDescription } from '../../../models/business-description.model';
import { CompanyInfo } from '../../../models/company-info.model';
import { Financial } from '../../../models/financial.model';
import { CompanyDetails } from './models/company-details.model';

export const loadCompanyDetails = createAction('[Company Drill Down] Load Company Details', props<{ id: number; databaseId: number }>());

export const companyDetailsLoaded = createAction(
  '[Drill Down Effects] Company Details Loaded',
  props<{ id: number; databaseId: number; detils: CompanyDetails }>()
);

export const companyDetailsLoadFailed = createAction('[Drill Down Effects] Company Details Load Failed', props<{ id: number }>());

export const loadIndustryDescriptions = createAction(
  '[Company Drill Down] Load Industry Descriptions',
  props<{ id: number; uniqueId: number; databaseId: number }>()
);

export const industryDescriptionsLoaded = createAction(
  '[Drill Down Effects] Industry Descriptions Loaded',
  props<{ id: number; databaseId: number; data: string[] }>()
);

export const industryDescriptionsLoadFailed = createAction('[Drill Down Effects] Industry Descriptions Load Failed', props<{ id: number }>());

export const updateIndustryDescriptionsSelectedDatabaseId = createAction(
  '[Company Drill Down] Update Industry Descriptions Selected Database Id',
  props<{ id: number; databaseId: number }>()
);

export const updateIndustryDescriptionsCurrentDatabaseId = createAction(
  '[Company Drill Down] Update Industry Descriptions Current Database Id',
  props<{ id: number; databaseId: number }>()
);

export const loadCompanyInfo = createAction('[Company Drill Down] Load Company Info', props<{ id: number; uniqueId: number; databaseId: number }>());

export const companyInfoLoaded = createAction(
  '[Drill Down Effects] Company Info Loaded',
  props<{ id: number; databaseId: number; data: CompanyInfo }>()
);

export const companyInfoLoadFailed = createAction('[Drill Down Effects] Company Info Load Failed', props<{ id: number }>());

export const updateCompanyInfoSelectedDatabaseId = createAction(
  '[Company Drill Down] Update Company Info Selected Database Id',
  props<{ id: number; databaseId: number }>()
);

export const updateCompanyInfoCurrentDatabaseId = createAction(
  '[Company Drill Down] Update Company Info Current Database Id',
  props<{ id: number; databaseId: number }>()
);

export const loadBusinessDescription = createAction(
  '[Company Drill Down] Load Business Description',
  props<{ id: number; uniqueId: number; databaseId: number }>()
);

export const businessDescriptionLoaded = createAction(
  '[Drill Down Effects] Business Description Loaded',
  props<{ id: number; databaseId: number; data: BusinessDescription }>()
);

export const businessDescriptionLoadFailed = createAction('[Drill Down Effects] Business Description Load Failed', props<{ id: number }>());

export const updateBusinessDescriptionSelectedDatabaseId = createAction(
  '[Company Drill Down] Update Business Description Selected Database Id',
  props<{ id: number; databaseId: number }>()
);

export const updateBusinessDescriptionCurrentDatabaseId = createAction(
  '[Company Drill Down] Update Business Description Current Database Id',
  props<{ id: number; databaseId: number }>()
);

export const reloadFinancialInitial = createAction(
  '[Company Drill Down] Reload Financial Initial',
  props<{ id: number; uniqueId: number; databaseId: number; consolidated: boolean; currencyId: number; functionalCurrency: boolean }>()
);

export const loadFinancialInitial = createAction(
  '[Drill Down Effects] Load Financial Initial',
  props<{ id: number; uniqueId: number; databaseId: number; consolidated: boolean; currencyId: number; functionalCurrency: boolean }>()
);

export const financialInitialLoaded = createAction(
  '[Drill Down Effects] Financial Initial Loaded',
  props<{ id: number; databaseId: number; consolidated: boolean; currencyId: number; data: Financial }>()
);

export const financialInitialLoadFailed = createAction('[Drill Down Effects] Financial Initial Load Failed', props<{ id: number }>());

export const loadFinancial = createAction(
  '[Company Drill Down] Load Financial',
  props<{ id: number; uniqueId: number; databaseId: number; consolidated: boolean; currencyId: number; functionalCurrency: boolean }>()
);

export const financialLoaded = createAction(
  '[Drill Down Effects] Financial Loaded',
  props<{ id: number; databaseId: number; consolidated: boolean; currencyId: number; data: Financial }>()
);

export const financialLoadFailed = createAction('[Drill Down Effects] Financial Load Failed', props<{ id: number }>());

export const updateFinancialDataSelectedDatabaseId = createAction(
  '[Company Drill Down] Update Financial Data Selected Database Id',
  props<{ id: number; databaseId: number }>()
);

export const updateFinancialDataCurrentDatabaseId = createAction(
  '[Company Drill Down] Update Financial Data Current Database Id',
  props<{ id: number; databaseId: number }>()
);

export const updateFinancialDataSelectedCurrencyId = createAction(
  '[Company Drill Down] Update Financial Data Selected Currency Id',
  props<{ id: number; currencyId: number }>()
);

export const updateFinancialDataCurrentCurrencyId = createAction(
  '[Company Drill Down] Update Financial Data Current Currency Id',
  props<{ id: number; currencyId: number }>()
);

export const updateFinancialDataSelectedConsolidated = createAction(
  '[Company Drill Down] Update Financial Data Selected Consolidated',
  props<{ id: number; consolidated: boolean }>()
);

export const updateFinancialDataCurrentConsolidated = createAction(
  '[Company Drill Down] Update Financial Data Current Consolidated',
  props<{ id: number; consolidated: boolean }>()
);

export const clearState = createAction('[Company Drill Down] Clear State');

export const updateNavigationPage = createAction('[Company Drill Down] Update Navigation Page', props<{ page: number; index: number }>());

export const updateNavigationIndex = createAction('[Company Drill Down] Update Navigation Index', props<{ index: number }>());

export const updateSelectedComparableId = createAction('[Company Drill Down] Update Selected Comparable Id', props<{ id: number }>());

export const updateSelectionData = createAction(
  '[Company Drill Down] Update Selection Data',
  props<{ id: number; databaseId: number; currencyId: number; isConsolidated: boolean }>()
);

export const invalidateInitLoad = createAction('[Company Drill Down] Invalidate Init Load');

export const setPageDataRequestIndication = createAction('[Company Drill Down] Set Page Data Request Indication');
